/* eslint-disable react/prop-types */
import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import {
  Grid,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import LoginMenu from '../../../../components/LoginMenu/LoginMenu';
import mc from '../../../../assets/Images/mastervisacard.jpeg';
import PayViaBankTransfer from '../HelperChunks/PayViaBankTransfer';

const styles = () => ({
  root: {
    flexGrow: 1,
    margin: 10,
    padding: 10,
  },
  blockStyle: {
    paddingLeft: 10,
    paddingTop: 10,
    paddingBottom: 10,
    textAlign: "left",
    border: "1px solid rgb(211, 211, 211)",
    borderRadius: 5,
  },
});

const useStyles = makeStyles(styles);

const RegistrationFeePayment = (props) => {
  const classes = useStyles();
  const [state, setState] = useState({
    /*Country */
    payment_term: false,
    payment_term_val: "",
    payment_term_error: "",

    /**Db Values */
    id: "",
    voucher_no: "",
    created_on: "",
    due_date: "",
    amount: "",
    status_id: "",
    status_label: "",
    status_changed_on: "",

    isDialogOpen: false,
    isLoginMenu: false,
    isReload: false,

    // isLoading was missing in initial state of source code class property?
    // Added here for safety as it is used.
    isLoading: false,

    form: {
      paymentDate: null,
      referenceNo: null,
      files: []
    },

    formErrors: {
      paymentDate: "",
      referenceNoError: "",
      filesError: "",
    },
    refCheck: false,
    uploadData: [],
  });

  const updateState = (updates) => setState(prev => ({ ...prev, ...updates }));

  useEffect(() => {
    loadingData();
    updateState({
      isDialogOpen: props.success,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const payment_term = (event) => {
    updateState({ payment_term_val: event.target.value });
  };

  const loadData = async () => {
    let url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C01CommonAcademicsFeePayableView`;
    try {
      const res = await fetch(url, {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + localStorage.getItem("uclToken"),
        }),
      });
      if (!res.ok) throw res;
      const json = await res.json();

      if (json.CODE === 1) {
        if (json.DATA && json.DATA.length > 0) {
          updateState({
            id: json.DATA[0].id,
            voucher_no: json.DATA[0].voucherNo,
            created_on: json.DATA[0].createdOn,
            due_date: json.DATA[0].dueDate,
            amount: json.DATA[0].amount,
            status_id: json.DATA[0].statusId,
            status_label: json.DATA[0].statusLabel,
            status_changed_on: json.DATA[0].statusChangedOn,
          });
        }
      } else {
        alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE);
      }
      console.log(json);
    } catch (error) {
      if (error.status == 401) {
        updateState({
          isLoginMenu: true,
          isReload: true
        });
      } else {
        alert('Operation Failed, Please try again later.');
        console.log(error);
      }
    }
  };

  const getUploadData = async () => {
    let url =
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationDocumentsBankReceiptView`;
    try {
      const res = await fetch(url, {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + localStorage.getItem("uclToken"),
        }),
      });
      if (!res.ok) throw res;
      const result = await res.json();

      if (result.CODE === 1) {
        updateState({
          uploadData: result.DATA
        });
      } else if (result.error == 1) {
        alert(result.error_message);
      } else if (result.success == 0 && result.redirect_url != "") {
        window.location = result.redirect_url;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const loadingData = async () => {
    updateState({ isLoading: true });
    await loadData();
    await getUploadData();
    updateState({ isLoading: false });
  };


  const handleBankToggle = () => {
    const { isBankOpen } = state;
    const form = { ...state.form };
    const formErrors = { ...state.formErrors };

    form.referenceNo = "";
    formErrors.referenceNoError = "";
    form.files = [];
    formErrors.filesError = "";
    form.paymentDate = null;
    formErrors.paymentDate = "";

    updateState({
      isBankOpen: !isBankOpen,
      form,
      formErrors
    });
  };

  const onRefCheckChnage = (e) => {
    const { checked } = e.target;
    const form = { ...state.form };
    const formErrors = { ...state.formErrors };

    form.referenceNo = "";
    formErrors.referenceNoError = "";
    updateState({
      refCheck: checked,
      form,
      formErrors
    });
  };

  const handleChange = (e) => {
    const form = { ...state.form };
    const formErrors = { ...state.formErrors };
    const { name, value } = e.target;
    form[name] = value;
    formErrors[`${name}Error`] = "";
    updateState({
      form,
      formErrors,
    });
  };

  const handleFileChange = event => {
    const { files = [] } = event.target;
    const form = { ...state.form };
    const formErrors = { ...state.formErrors };
    form.files = files;
    formErrors.filesError = "";
    updateState({
      form,
      formErrors
    });
  };

  const handleDateChange = (date) => {
    const form = { ...state.form };
    const formErrors = { ...state.formErrors };
    form["paymentDate"] = date;
    formErrors["paymentDate"] = "";
    updateState({
      form,
      formErrors,
    });
  };

  const isFormValid = () => {
    const { form, refCheck } = state;
    const formErrors = { ...state.formErrors };
    let isValid = true;
    if (!form.referenceNo && !refCheck) {
      formErrors.referenceNoError = "Please provide Transaction Id";
      isValid = false;
    }
    if (!form.paymentDate) {
      formErrors.paymentDate = "Please provide payment date";
      isValid = false;
    }

    if (form.files.length <= 0) {
      formErrors.filesError = "Please select a file.";
      isValid = false;
    }

    updateState({
      formErrors,
    });

    return isValid;
  };

  const handleSubmitButtonClick = () => {
    const isValid = isFormValid();
    if (isValid) {
      const btn = document.getElementById("submit-button");
      if (btn) btn.click();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    updateState({
      isLoading: true,
    });
    const endPoint = 'C01AdmissionsProspectApplicationDocumentsUpload';
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/${endPoint}`;
    console.log(url);

    try {
      const res = await fetch(url, {
        method: "POST",
        body: data,
        headers: new Headers({
          Authorization: "Bearer " + localStorage.getItem("uclToken"),
        }),
      });
      if (!res.ok) throw res;
      const result = await res.json();

      if (result.CODE == 1) {
        alert("File uploaded, thank you");
        window.localStorage.setItem("isChallanUploaded", 1);
        loadingData();
        handleBankToggle();
      } else if (result.CODE == 2) {
        alert(result.CODE + ":" + result.USER_MESSAGE);
      } else if (result.CODE == 3) {
        alert(result.CODE + ":" + result.SYSTEM_MESSAGE);
      } else if (result.error == 1) {
        alert(result.error_message);
      }
    } catch (error) {
      if (error.status == 401) {
        updateState({
          isLoginMenu: true,
          isReload: false
        });
      } else {
        alert('Operation Failed, Please try again later.');
        console.log(error);
      }
    }
    updateState({
      isLoading: false,
    });
  };

  const deleteFile = (id) => {
    const data = new FormData();
    data.append("documentTypeId", id);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationDocumentsDelete`;
    console.log("URLL ==>> " + url);

    fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) throw res;
        return res.json();
      })
      .then((result) => {
        console.log(result);
        if (result["CODE"] == 1) {
          loadingData();
          alert('File Deleted');
        } else if (result.error == 1) {
          alert(result.error_message);
        } else if (result.success == 0 && result.redirect_url != "") {
          window.location = result.redirect_url;
        }
      })
      .catch((error) => {
        if (error.status == 401) {
          updateState({
            isLoginMenu: true,
            isReload: false
          });
        } else {
          alert('Operation Failed, Please try again later.');
          console.log(error);
        }
      });
  };

  const DownloadFile = (fileName) => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME
      }/common/CommonViewFile?fileName=${encodeURIComponent(fileName)}`;

    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.blob();
        } else if (res.status === 401) {
          updateState({
            isLoginMenu: true,
            isReload: false
          });
          return {};
        } else {
          alert('Operation Failed, Please try again later.');
          return {};
        }
      })
      .then((result) => {
        if (!(result instanceof Blob)) return;
        var csvURL = window.URL.createObjectURL(result);
        var tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", fileName);
        tempLink.click();
        console.log(csvURL);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const isSaved = localStorage.getItem("isSaved");
  const isSubmitted = localStorage.getItem("isSubmitted");
  const isChallanUploaded = localStorage.getItem("isChallanUploaded");

  return (
    <Fragment>
      <LoginMenu reload={state.isReload} open={state.isLoginMenu} handleClose={() => updateState({ isLoginMenu: false })} />

      {state.isBankOpen && <PayViaBankTransfer type={0} handleClose={() => handleBankToggle()}
        onRefCheckChnage={(e) => onRefCheckChnage(e)} handleChange={(e) => handleChange(e)}
        handleFileChange={(e) => handleFileChange(e)} handleDateChange={date => handleDateChange(date)} downloadFile={name => DownloadFile(name)}
        values={state} deleteFile={id => deleteFile(id)} handleSubmit={(e) => handleSubmit(e)} handleSubmitButtonClick={() => handleSubmitButtonClick()} />}
      {!state.isBankOpen && <Fragment>

        <Dialog
          open={isSubmitted == 0}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Application Not Submitted"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please submit your application in the <b>Review & Submit Application</b> section to proceed to the <b>Registration Fee Payment</b>.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="outlined"
              style={{
                marginBottom: 10,
                marginRight: 10,
                minWidth: 150,
                textTransform: "capitalize",
                color: "#303F9F",
                borderColor: "#303F9F",
              }}
              disabled={state.isLoading}

            >
              <Link style={{ textDecoration: 'none' }} to='/dashboard/review'>
                Go to Review & Submit Application
              </Link>
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={isSaved == 0}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Application Not Found"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please complete and submit your admission application.
              Registration fee challan will be generated after submission of
              your admission application.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="outlined"
              style={{
                marginBottom: 10,
                marginRight: 10,
                minWidth: 150,
                textTransform: "capitalize",
                color: "#303F9F",
                borderColor: "#303F9F",
              }}
              disabled={state.isLoading}
            >
              <Link
                style={{ textDecoration: "none" }}
                to="/dashboard/admission-application"
              >
                Go to Admission Application
              </Link>
            </Button>
          </DialogActions>
        </Dialog>

        <ControlledDialog
          open={state.isDialogOpen}
          handleClose={() => updateState({ isDialogOpen: false })}
          title="Success"
          content="Your registration fee has been paid. Thank you for applying to UCL. Our admissions team will get in touch with you soon."
        />
        <div className={classes.root}>
          <Typography
            style={{
              color: "#1d5f98",
              fontWeight: 600,
              fontSize: 20,
            }}
            variant="h5"
          >
            Registration Fee Payment
          </Typography>
          <Divider
            style={{
              backgroundColor: "rgb(58, 127, 187)",
              opacity: "0.3",
            }}
          />
          {isChallanUploaded == 1 && (
            <div style={{ marginTop: 10 }}>
              Dear Applicant, Thank you for uploading the Registration Fee Payment Evidence. Our admission team will verify it and email you regarding your payment status soon.
            </div>
          )}
          <div
            style={{
              marginTop: "25px",
              marginBottom: "60px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <form id="myform" onSubmit={handleSubmit} autoComplete="off">
              {/* Added hidden button for programmatic submit */}
              <button type="submit" id="submit-button" style={{ display: 'none' }} />

              <input type="hidden" name="id" value={1400}></input>
              <input type="hidden" name="createdBy" value={123}></input>
              <input type="hidden" name="isActive" value={1}></input>
              <Grid direction="row" container spacing={1}>
                {/* ... table structure ... */}
                <Grid item xs={1} align="left"></Grid>
                <Grid item xs={12} sm={12}>
                  <table
                    style={{
                      width: "100%",
                      borderColor: "",
                      borderRadius: "5px",
                    }}
                  >
                    <thead>
                      <tr>
                        <th className={classes.blockStyle}>
                          <Typography color="primary" style={{ fontWeight: "bold", fontSize: "16px" }}>Student Id</Typography>
                        </th>
                        <td className={classes.blockStyle} style={{ paddingRight: "350px" }}>{state.id || "--"}</td>
                      </tr>
                      <tr>
                        <th className={classes.blockStyle}>
                          <Typography color="primary" style={{ fontWeight: "bold", fontSize: "16px" }}>Voucher No</Typography>
                        </th>
                        <td className={classes.blockStyle} style={{ paddingRight: "350px" }}>{state.voucher_no || "--"}</td>
                      </tr>
                      <tr>
                        <th className={classes.blockStyle}>
                          <Typography color="primary" style={{ fontWeight: "bold", fontSize: "16px" }}>Created On</Typography>
                        </th>
                        <td className={classes.blockStyle} style={{ paddingRight: "350px" }}>{state.created_on || "--"}</td>
                      </tr>
                      <tr>
                        <th className={classes.blockStyle}>
                          <Typography color="primary" style={{ fontWeight: "bold", fontSize: "16px" }}>Due Date</Typography>
                        </th>
                        <td className={classes.blockStyle} style={{ paddingRight: "350px" }}>{state.due_date || "--"}</td>
                      </tr>
                      <tr>
                        <th className={classes.blockStyle}>
                          <Typography color="primary" style={{ fontWeight: "bold", fontSize: "16px" }}>Amount</Typography>
                        </th>
                        <td className={classes.blockStyle} style={{ paddingRight: "350px" }}>{state.amount || "--"}</td>
                      </tr>
                      <tr>
                        <th className={classes.blockStyle}>
                          <Typography color="primary" style={{ fontWeight: "bold", fontSize: "16px" }}>Status</Typography>
                        </th>
                        {state.status_id == 2 ? (
                          <td className={classes.blockStyle} style={{ paddingRight: "350px", color: "#FCF6F5FF", backgroundColor: "#2BAE66FF" }}>
                            {state.status_label || "--"}
                          </td>
                        ) : (
                          <td className={classes.blockStyle} style={{ paddingRight: "350px" }}>
                            {state.status_label || "--"}
                          </td>
                        )}
                      </tr>
                      <tr>
                        <th className={classes.blockStyle}>
                          <Typography color="primary" style={{ fontWeight: "bold", fontSize: "16px" }}>Status Changed On</Typography>
                        </th>
                        <td className={classes.blockStyle} style={{ paddingRight: "450px" }}>{state.status_changed_on || "--"}</td>
                      </tr>
                    </thead>
                  </table>
                </Grid>
              </Grid>
            </form>
          </div>
          {isChallanUploaded == 0 && state.status_id == 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "-45px",
                marginRight: "15px",
              }}
            >
              <img src={mc} width={100} height={45} alt={"1"}></img>

              <Button
                variant="contained"
                color="inherit"
                style={{
                  marginLeft: "10px",
                  textTransform: "none",
                }}
                onClick={() =>
                  (window.location = `${process.env.REACT_APP_API_FEE_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/feePaymentAutoV2.html?109=11147`)
                }
              >
                Pay via Debit / Credit Card
              </Button>
              <Button
                variant="contained"
                onClick={() => handleBankToggle()}
                style={{
                  marginLeft: "10px",
                  textTransform: "none",
                }}
              >
                Pay via Bank Transfer
              </Button>
            </div>
          )}
        </div>
      </Fragment>}
    </Fragment>
  );
};

RegistrationFeePayment.propTypes = {
  success: PropTypes.bool,
};

RegistrationFeePayment.defaultProps = {
  success: false,
};

export default RegistrationFeePayment;
